import { Features } from "@/users/v3/features/queries.types";

export const featureMock: Features = [
  "can_onboard",
  "needs_initial_onboarding",
  "needs_returning_onboarding",
  "needs_onboarding",
  "can_create_classrooms",
  "can_sync_classrooms",
  "has_bulk_classrooms",
  "needs_assignment_builder_onboarding",
  "can_access_usage_report",
  "can_access_reading_skills_report",
  "is_new_user",
  "is_first_week_user",
  "is_first_month_user",
  "can_make_changes_in_admin_console",
  "can_view_admin_console",
  "can_access_implementation_guide",
  "can_view_content_settings",
  "can_modify_content_settings",
  "can_view_usage_report",
  "can_view_reading_skills_report",
  "can_see_progress_tracker",
  "can_see_trial_extension_banner",
  "is_administrator",
  "is_district_admin",
  "is_educator",
  "is_learner",
  "is_parent",
  "is_principal",
  "is_school_educator",
  "is_staff",
  "is_student",
  "is_teacher",
  "is_impersonated",
  "can_manage_their_roles",
  "can_print",
  "can_view_editing_tools",
  "can_view_search",
  "is_demo_user",
  "is_bulk_user",
  "is_in_bulk_district",
  "can_create_and_modify_content_promotion_configurations",
  "can_access_promoted_at_your_district_page",
  "can_see_everwrite",
  "can_see_formative",
  "can_see_ai_features",
  "can_view_wire_task_cost",
  "is_wire_admin",
  "is_wire_contributor",
  "is_wire_quiz_contributor",
  "is_wire_text_set_contributor",
  "is_wire_admin_taxonomy",
  "can_write_taxonomy_manager",
  "can_view_taxonomy_manager",
  "can_view_their_licenses",
  "has_access_to_lite",
  "is_lite_user",
  "has_ela_license",
  "has_science_license",
  "has_social_studies_license",
  "has_texas_ela_license",
  "has_active_premium_trial_campaign",
  "has_active_premium_trial_campaign_extension",
  "had_premium_trial_campaign_extension_this_school_year",
  "had_premium_trial_this_school_year",
  "can_start_premium_trial",
  "has_active_premium_trial",
  "has_school_poc_license",
  "had_school_poc_license",
  "has_nce_trial_campaign",
  "has_non_nce_or_premium_trial_campaign",
  "has_paid_essentials_license",
  "has_premium_license",
  "can_view_guided_highlighting",
  "can_view_irc",
  "needs_first_assignment",
  "needs_first_assignment_review",
  "needs_first_content_search",
  "needs_active_session_record",
  "needs_to_view_articles",
  "needs_to_setup_classrooms",
  "needs_teacher_referral",
  "needs_admin_referral",
  "needs_calendar_visit",
];
